<div class="date-filter-input">
  <glxy-form-field class="filter-operator-selector" [bottomSpacing]="'none'" *ngIf="!showDateRangePicker()">
    <mat-select
      [placeholder]="'GALAXY.FILTER.CHIP.SELECT_DATE_DEFAULT_OPTION' | translate"
      [formControl]="dateDefaultControl"
    >
      <ng-container *ngFor="let option of dateDefaultOptions()">
        <mat-option [value]="option.dateOption">{{ option.label | translate }}</mat-option>
      </ng-container>
    </mat-select>
  </glxy-form-field>
  <ng-container *ngIf="showDate$ | async">
    <ng-container *ngIf="showDateRangePicker(); else datePicker">
      <glxy-form-field class="filter-date-range-selector">
        <mat-datepicker-toggle matPrefix [for]="dateRangePicker" />
        <mat-date-range-input [rangePicker]="dateRangePicker">
          <input
            matStartDate
            placeholder="{{'GALAXY.FILTER.CHIP.SELECT_START_PLACEHOLDER' | translate}}"
            [formControl]="startDateControl"
          />
          <input
            matEndDate
            placeholder="{{'GALAXY.FILTER.CHIP.SELECT_END_PLACEHOLDER' | translate}}"
            [formControl]="endDateControl"
          />
        </mat-date-range-input>
        <mat-date-range-picker #dateRangePicker />
      </glxy-form-field>
    </ng-container>
  </ng-container>
  <ng-template #datePicker>
    <glxy-form-field class="filter-date-selector">
      <input matInput type="date" [formControl]="dateControl" />
    </glxy-form-field>
  </ng-template>
</div>
